<template>
    <div class="faqs-container my-5 px-1 px-md-5">
        <h2 class="title text-center mb-0" v-html="title"></h2>
        <div v-if="description" v-html="description"></div>
        <div class="faq-container" v-for="(faq, index) in faqs" :id="'faq-' + index">
            <div class="faq-header d-flex" :id="'faq-header-' + index" @click="toggleCard(index)">
                <i class="fa-sharp mr-3" :class="custom_faqs ? 'fa-chevron-down-custom' : 'fa-chevron-right'"
                   :id="'faq-arrow-' + index"></i>
                <h3 class="faq-question" style="font-size: 16px; color: gray" :id="'faq-question-' + index"><span>{{ faq.pregunta }}</span>
                </h3>
            </div>
            <div class="faq-body" :id="'faq-body-' + index" v-html="faq.respuestas ? faq.respuestas : faq.respuesta">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        faqs: Array,
        custom_faqs: {
            type: Boolean,
            default: false,
            required: false
        },
        backgroundColor: {
            type: String,
            default: 'var(--prestaprenda-orange)',
            required: false
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: 'Preguntas frecuentes'
        }
    },
    data() {
        return {
            selectedIndex: 0
        }
    },
    mounted() {
        this.toggleCard(0)
    },
    methods: {
        toggleCard(index) {
            trackClick('faqs', `articulo_${index}`)
            if (this.selectedIndex !== index) this.hideCard(this.selectedIndex)
            this.selectedIndex = index
            let header = document.querySelector('#faq-header-' + index)
            let arrow = document.querySelector('#faq-arrow-' + index)
            let body = document.querySelector('#faq-body-' + index)
            let card = document.querySelector('#faq-' + index)
            let question = document.querySelector('#faq-question-' + index)
            if (body.style.display === 'none' || body.style.display === '') {
                header.style.borderBottomLeftRadius = '0px'
                header.style.borderBottomRightRadius = '0px'
                body.style.display = 'block'

                header.style.border = `1px solid ${this.backgroundColor}`
                header.style.backgroundColor = this.backgroundColor

                if (!this.custom_faqs) {
                    header.style.color = 'white !important'
                    arrow.style.color = 'white'
                    question.style.color = 'white'
                    arrow.classList.add('rotate-animation')
                    if (arrow.classList.contains('rotate-animation-90')) arrow.classList.remove('rotate-animation-90')
                } else {
                    header.style.color = 'black'
                    arrow.style.color = '#FF8F22'
                    question.style.color = 'black'
                    header.style.border = 'none'
                    let icon = header.querySelector('i')
                    let label = header.querySelector('h3')
                    icon.style.order = '1'
                    label.style.order = '0'
                    arrow.classList.add('rotate-animation-custom')
                    if (arrow.classList.contains('rotate-animation-degrees')) arrow.classList.remove('rotate-animation-degrees')
                }

            } else {
                this.hideCard(index)
            }
        },
        hideCard(index) {
            let header = document.querySelector('#faq-header-' + index)
            let arrow = document.querySelector('#faq-arrow-' + index)
            let body = document.querySelector('#faq-body-' + index)
            let card = document.querySelector('#faq-' + index)
            let question = document.querySelector('#faq-question-' + index)
            header.style.backgroundColor = 'white'
            header.style.borderBottomLeftRadius = '5px'
            header.style.borderBottomRightRadius = '5px'
            body.style.display = 'none'

            if (!this.custom_faqs) {
                header.style.border = '1px solid lightgray'
                header.style.color = 'gray'
                arrow.style.color = 'gray'
                question.style.color = 'gray'
                arrow.classList.remove('rotate-animation')
                arrow.classList.add('rotate-animation-90')
            } else {
                header.style.color = 'black'
                arrow.style.color = '#FF8F22'
                question.style.color = 'black'
                let icon = header.querySelector('i')
                let label = header.querySelector('h3')
                icon.style.order = '1'
                label.style.order = '0'
                arrow.classList.remove('rotate-animation-custom')
                arrow.classList.add('rotate-animation-degrees')
            }

        }

    }
}
</script>

<style lang="scss" scoped>
.faq-container {
    color: gray;
    margin-bottom: 15px;

    &:hover {
        cursor: pointer;
    }
}

.faq-header {
    display: flex;
    align-items: center;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 0 20px;
}

.faq-body {
    padding: 20px;
    border: 1px solid lightgray;
    max-height: fit-content;
    display: none;
    text-align: justify;
}

.rotate-animation {
    animation: rotate90 .5s forwards;
}

.rotate-animation-90 {
    animation: rotate-90 .5s forwards;
}

@keyframes rotate90 {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(90deg);
    }
}

@keyframes rotate-90 {
    0% {
        transform: rotate(90deg);
    }
    100% {
        transform: rotate(0deg);
    }
}
</style>